const dispatcher = require('./dispatcher');
const reader = require('./helpers/reader');
const SubtitleScope = require('./scopes/subtitle');
const STATUSES = SubtitleScope.VARIABLES.STATUSES;
import { consts} from './helpers/consts';

class CaptionsWaveFormModel {
    constructor(appModel, onNewTimeRequest, onCaptionChanged) {
        this._appModel = appModel;
        this._playTime = 0;
        this._onNewTimeRequest = onNewTimeRequest;
        this._onCaptionChanged = onCaptionChanged;
        this._previewCaption = null;
    }

    get captions() {
        return this._appModel.attributes.subtitle.models
            .filter(subtitleModel => {
                return subtitleModel.get('status') != STATUSES.DELETED
            })
            .map(subtitleModel => {
                var dto = this._toCaptionDto(subtitleModel);
                if (this._previewCaption && dto.id == this._previewCaption.id) {
                    dto.startTime = reader.framesToMs(this._previewCaption.frameStart);
                    dto.endTime = reader.framesToMs(this._previewCaption.frameEnd);
                }
                return dto;
            })
    }

    get waveFileUrl() {
        return consts.BASE_END_POINT + '/AudioWave/get?movieId=' + this._appModel.attributes.movieId;
    }

    get scenesChangesUrl() {
        return consts.BASE_END_POINT + '/AudioWave/GetScenesChanges?movieId=' + this._appModel.attributes.movieId;
    }

    set playTime(newPlayTime) {
        this._playTime = newPlayTime;
    }

    get playTime() {
        return this._playTime || 0;
    }

    get frameRate() {
        return this._appModel.attributes.frameRate;
    }

    getPlayTime() {
        return this.playTime;
    }

    onNewTimeRequest(time) {
        this._onNewTimeRequest && this._onNewTimeRequest(time);
    }

    onCaptionChanged(caption) {
        this._onCaptionChanged && this._onCaptionChanged({
            id: caption.id,
            frameStart: reader.msToFrames(caption.startTime),
            frameEnd: reader.msToFrames(caption.endTime)
        });
    }

    _toCaptionDto(subtitleModel) {
        let rawSubtitleModel = subtitleModel.getCurrentModel().attributes;

        return {
            id: subtitleModel.get('id'),
            startTime: reader.framesToMs(rawSubtitleModel.frameStart),
            endTime: reader.framesToMs(rawSubtitleModel.frameEnd),
            text: [rawSubtitleModel.row1, rawSubtitleModel.row2]
        }
    }
}

class CaptionsWaveAdapter {
    constructor() {
        this.videoPlayTime = 0;
        this.captionsWaveFormModel = null;
        this._lastChangedCaptionId = null;
        this._subscribe();
    }

    _subscribe() {
        dispatcher.subscribe(dispatcher.events.APP_MODEL_INITIALIZED, appModel => {
            let isCaptionsWaveLoadedOnPage = window.capNsubAdapter != null;
            if (!isCaptionsWaveLoadedOnPage) {
                return;
            }
            this.captionsWaveFormModel = new CaptionsWaveFormModel(appModel, this._onNewTimeRequest, this._onCaptionChanged.bind(this));
            window.capNsubAdapter.captionsWave.activate(this.captionsWaveFormModel);
        });

        dispatcher.subscribe(dispatcher.events.NEW_PLAY_TIME, newVideoPlayTime => {
            if (this.captionsWaveFormModel) {
                this.captionsWaveFormModel.playTime = newVideoPlayTime * 1000;
                window.capNsubAdapter.updateEmitter.emit('time');
            }
        })
        dispatcher.subscribe(dispatcher.events.DB_UPDATE_SUBTITLE_FAILURE, () => this._emitRefreshCaptionsRequesut());
        dispatcher.subscribe(dispatcher.events.UPDATE_LAST_SYNC_TIME, () => this._emitRefreshCaptionsRequesut());
        dispatcher.subscribe(dispatcher.events.CAPTION_TIMECODES_PREVIEW, (previewData) => {
            if (this.captionsWaveFormModel && previewData) {
                window.capNsubAdapter.updateEmitter.emit({
                    type: 'captionPreview',
                    id: previewData.id,
                    startTime: reader.framesToMs(previewData.frameStart),
                    endTime: reader.framesToMs(previewData.frameEnd)
                });
            }
        });
    }

    _onCaptionChanged(captionBasicTimesData) {
        this._lastChangedCaptionId = captionBasicTimesData.id;
        dispatcher.emit(dispatcher.events.REQUEST_CAPTION_UPDATE, captionBasicTimesData);
    }

    _onNewTimeRequest(newVideoTime) {
        dispatcher.emit(dispatcher.events.REQUEST_PLAY_TIME_CHANGE, newVideoTime / 1000);
    }

    _emitRefreshCaptionsRequesut() {
        if (this.captionsWaveFormModel) {
            if (this._lastChangedCaptionId != null) {
                this._lastChangedCaptionId = null;
                return;
            }
            setTimeout(() => {
                window.capNsubAdapter.updateEmitter.emit('captions');
            })
        }
    }

}



module.exports = new CaptionsWaveAdapter();


// WEBPACK FOOTER //
// ./app/captions-wave-adapter.js